module.exports = __webpack_public_path__ + "img/street-view.be3f2058.svg";